var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"specification-tab",class:{'active': _vm.isActive},on:{"click":_vm.emitChangeTab}},[_c('base-font',{staticClass:"specification-tab-title",attrs:{"variant":"specification-tab","weight":"semibold"}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }